/* eslint-disable no-console */
import * as api from './api'
import * as reducers from './slice-reducers'
import { AppDispatch } from 'src/app/store'
import {
  setNewCtSidCookie,
  updateCtSidCookie,
  setNewCtVidCookie,
  updateCtVidCookie,
  getCtCookie
} from 'src/core/helpers'
import { ct_sid_name, ct_vid_name } from '../../core/models'


export const checkCookies = () => async (dispatch: AppDispatch) => {
  const ct_sid_cookie = getCtCookie(ct_sid_name)
  const ct_vid_cookie = getCtCookie(ct_vid_name)

  // Check CT Session ID Cookie
  if (!ct_sid_cookie) setNewCtSidCookie()
  else updateCtSidCookie()

  // Check CT Visitor ID Cookie
  if (!ct_vid_cookie) setNewCtVidCookie()
  else updateCtVidCookie()

  // Create Visitor
  await api.postVisitorAPI({ ct_vid: getCtCookie(ct_vid_name) })
  dispatch(reducers.setCookiesLoading(false))
}

export const trackEvent = (url: string, event: string, eventValue = null) => async () => {
  try {
    await api.postTrackingEventAPI(url, event, eventValue)
  } catch (error) {
    console.log(`Error on Tracking event`, error)
  }
}
